module.exports = __webpack_public_path__ + "img/2.520b231f.png";